// extracted by mini-css-extract-plugin
export var aboveInput = "_mx-0";
export var actionButton = "_mx-5";
export var actionButtonContainer = "_mx-1";
export var actionIcon = "_mx-6";
export var aiInfoContainer = "_mx-2";
export var attachmentWrapper = "_mx-7";
export var bold = "_mx-3";
export var checkIcon = "_mx-8";
export var clickingRecipientBar = "_mx-11";
export var commentThreadSwitch = "_mx-a";
export var draftImage = "_mx-b";
export var draftImageContainer = "_mx-c";
export var draftImages = "_mx-e";
export var editButton = "_mx-g";
export var editor = "_mx-f";
export var editorContainer = "_mx-y";
export var editorErrorTooltipWrapper = "_mx-9";
export var headerDivider = "_mx-h";
export var icon = "_mx-i";
export var info = "_mx-j";
export var internal = "_mx-n";
export var internalDivider = "_mx-k";
export var internalMessage = "_mx-l";
export var messageInputCard = "_mx-m";
export var messageInputForm = "_mx-o";
export var messageInputFormInternal = "_mx-p";
export var options = "_mx-q";
export var publicMessageCustomer = "_mx-s";
export var publicMessageMerchant = "_mx-r";
export var removeImageButton = "_mx-d";
export var replyButtons = "_mx-t";
export var showSignatureButton = "_mx-u";
export var spinner = "_mx-v";
export var verticalButtonDivider = "_mx-4";
export var visibilitySelector = "_mx-w";
export var warning = "_mx-x";
export var wrappingText = "_mx-z";
export var writingInternalNoteTopBorder = "_mx-10";